<template>
  <div class="l-footer">
    <div class="l-actions">
      <slot />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="postcss" scoped>
.l-footer {
  /* Base */
  @apply tw-flex tw-flex-col tw-items-stretch tw-mt-7 tw-mb-8 tw-mx-6;
  /* Desktop */
  @apply lg:tw-items-center;
}

.l-footer >>> button {
  /* Desktop */
  @apply lg:tw-min-w-[288px];
}

.l-actions {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-4;

  /* Desktop */
  @apply lg:tw-flex-row-reverse;
}
</style>
